// Auto-generated: country slug -> flag emoji
export const countryFlags = {
    'USA1': '🇺🇸',
    'USA2': '🇺🇸',
    'afghanistan': '🇦🇫',
    'albania': '🇦🇱',
    'algeria': '🇩🇿',
    'andorra': '🇦🇩',
    'angola': '🇦🇴',
    'argentina': '🇦🇷',
    'australia': '🇦🇺',
    'austria': '🇦🇹',
    'bangladesh': '🇧🇩',
    'belarus': '🇧🇾',
    'belgium': '🇧🇪',
    'bolivia': '🇧🇴',
    'bosnia_and_herzegovina': '🇧🇦',
    'botswana': '🇧🇼',
    'brazil': '🇧🇷',
    'bulgaria': '🇧🇬',
    'cambodia': '🇰🇭',
    'cameroon': '🇨🇲',
    'canada': '🇨🇦',
    'chile': '🇨🇱',
    'china': '🇨🇳',
    'colombia': '🇨🇴',
    'costa_rica': '🇨🇷',
    'croatia': '🇭🇷',
    'cuba': '🇨🇺',
    'cyprus': '🇨🇾',
    'czech_republic': '🇨🇿',
    'democratic_republic_of_congo': '🇨🇩',
    'denmark': '🇩🇰',
    'dominican_republic': '🇩🇴',
    'ecuador': '🇪🇨',
    'egypt': '🇪🇬',
    'el_salvador': '🇸🇻',
    'estonia': '🇪🇪',
    'ethiopia': '🇪🇹',
    'finland': '🇫🇮',
    'france': '🇫🇷',
    'germany': '🇩🇪',
    'ghana': '🇬🇭',
    'greece': '🇬🇷',
    'guatemala': '🇬🇹',
    'honduras': '🇭🇳',
    'hungary': '🇭🇺',
    'iceland': '🇮🇸',
    'india': '🇮🇳',
    'indonesia': '🇮🇩',
    'iran': '🇮🇷',
    'iraq': '🇮🇶',
    'ireland': '🇮🇪',
    'israel': '🇮🇱',
    'italy': '🇮🇹',
    'jamaica': '🇯🇲',
    'japan': '🇯🇵',
    'jordan': '🇯🇴',
    'kazakhstan': '🇰🇿',
    'kenya': '🇰🇪',
    'kuwait': '🇰🇼',
    'laos': '🇱🇦',
    'latvia': '🇱🇻',
    'lebanon': '🇱🇧',
    'lithuania': '🇱🇹',
    'luxembourg': '🇱🇺',
    'madagascar': '🇲🇬',
    'malaysia': '🇲🇾',
    'malta': '🇲🇹',
    'mexico': '🇲🇽',
    'moldova': '🇲🇩',
    'monaco': '🇲🇨',
    'montenegro': '🇲🇪',
    'morocco': '🇲🇦',
    'mozambique': '🇲🇿',
    'myanmar': '🇲🇲',
    'namibia': '🇳🇦',
    'nepal': '🇳🇵',
    'netherlands': '🇳🇱',
    'new_zealand': '🇳🇿',
    'nicaragua': '🇳🇮',
    'nigeria': '🇳🇬',
    'north_korea': '🇰🇵',
    'north_macedonia': '🇲🇰',
    'norway': '🇳🇴',
    'pakistan': '🇵🇰',
    'panama': '🇵🇦',
    'papua_new_guinea': '🇵🇬',
    'paraguay': '🇵🇾',
    'peru': '🇵🇪',
    'philippines': '🇵🇭',
    'poland': '🇵🇱',
    'portugal': '🇵🇹',
    'qatar': '🇶🇦',
    'romania': '🇷🇴',
    'russia': '🇷🇺',
    'san_marino': '🇸🇲',
    'saudi_arabia': '🇸🇦',
    'senegal': '🇸🇳',
    'serbia': '🇷🇸',
    'singapore': '🇸🇬',
    'slovakia': '🇸🇰',
    'slovenia': '🇸🇮',
    'south_africa': '🇿🇦',
    'south_korea': '🇰🇷',
    'spain': '🇪🇸',
    'sri_lanka': '🇱🇰',
    'sweden': '🇸🇪',
    'switzerland': '🇨🇭',
    'syria': '🇸🇾',
    'taiwan': '🇹🇼',
    'tanzania': '🇹🇿',
    'thailand': '🇹🇭',
    'tunisia': '🇹🇳',
    'turkey': '🇹🇷',
    'uganda': '🇺🇬',
    'ukraine': '🇺🇦',
    'united_arab_emirates': '🇦🇪',
    'united_kingdom': '🇬🇧',
    'uruguay': '🇺🇾',
    'venezuela': '🇻🇪',
    'vietnam': '🇻🇳',
    'yemen': '🇾🇪',
    'zambia': '🇿🇲',
    'zimbabwe': '🇿🇼',
};

export const getCountryFlag = (key) => countryFlags[key] || '';